import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import { useAuth } from "context/AuthContext";

function QBPayment() {
  const { user } = useAuth();
  const qbToken = process.env.REACT_APP_QB_PAYMENT_TOKEN || "";
  const apiMain = process.env.REACT_APP_QB_API_MAIN || "";
  const apiGuest = process.env.REACT_APP_QB_API_GUEST || "";
  const apiUsdRate = process.env.REACT_APP_QB_API_USD_RATE || "";

  const iframeContent = (
    <MDBox style={{ height: "calc(100vh - 120px)", overflow: "hidden" }}>
      <iframe
        src={`/Quick-Books-Payment.html?token=${encodeURIComponent(qbToken)}&main=${encodeURIComponent(apiMain)}&guest=${encodeURIComponent(apiGuest)}&usdRate=${encodeURIComponent(apiUsdRate)}`}
        style={{
          width: "100%",
          height: "100%",
          border: "none",
          borderRadius: "14px",
          backgroundColor: "#f5f6f2", // Matches the var(--bg) from the original HTML
        }}
        title="QB Payment Dashboard"
      />
    </MDBox>
  );

  if (user?.role === "user") {
    return iframeContent;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {iframeContent}
    </DashboardLayout>
  );
}

export default QBPayment;
